/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { ErrorBoundary } from "react-error-boundary";
import { FieldErrorFallback } from "cms/fields/layout/field-error";
import { useUpdateComponent } from "cms/components/hooks/use-update-component";
import { IconLink } from "cms/components/components/icon-links-list/edit/icon-link/icon-link";
import { IconLinkEditWrapper } from "cms/components/components/icon-links-list/edit/icon-link-wrapper";
import { useTranslation } from "react-i18next";
import { TextField } from "@mui/material";
import LabelledField from "components/labelled-field";

const IconLinkListComponentEditor = () => {

    const { t } = useTranslation();
    const { component, update } = useUpdateComponent();
    const { icon_links } = component;

    const onChangeTitle = (event) => {
        const title = event.target.value;
        update("title", title);
    };
    const onChangeList = (icon_links) => {
        update("icon_links", icon_links);
    };

    return (
        <div className='simplicity-editor-frame'>
            <ErrorBoundary
                FallbackComponent={FieldErrorFallback}
                onReset={() => {
                    location.reload(); 
                }}
            >

                <LabelledField label={`${t("commons.title")} :`}>
                    <TextField
                        id='section_list_title'
                        fullWidth={true}
                        value={component.title}
                        placeholder={t("commons.addListTitleOptional")}
                        onChange={onChangeTitle}
                    />
                </LabelledField>

                <IconLinkEditWrapper
                    icon_links={icon_links}
                    onChangeList={onChangeList}
                >

                    {/* Icon Link */}
                    <IconLink />

                </IconLinkEditWrapper>

            </ErrorBoundary>
        </div>
    );
};

IconLinkListComponentEditor.displayName = "IconLinkListComponentEditor";
export { IconLinkListComponentEditor };
